import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FoodsService {

  
  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Foods/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

GetAllByCountryId(countryId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Foods/GetAllByCountryId/${countryId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}Foods/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

}
